if (!window.siCartDrawerBound) {
  window.siCartDrawerBound = true;
  const syncReprise = cart => {
    const count = document.querySelector('[data-si-cart-count]');
    if (count) count.textContent = cart.item_count;
    const box = document.querySelector('#cart-drawer .si-reprise__check');
    if (box) box.checked = cart.attributes?.["Reprise de l'ancien meuble"] === 'Oui';
  };
  document.addEventListener('on:cart-drawer:before-open', async () => {
    try {
      const response = await fetch(theme.routes.cart + '.js', {headers:{Accept:'application/json'}, cache:'no-store'});
      if (response.ok) syncReprise(await response.json());
    } catch {}
  });
  document.addEventListener('on:line-item:change', event => {
    if (event.detail?.cart) syncReprise(event.detail.cart);
  });
  document.addEventListener('change', async event => {
    const box = event.target.closest('#cart-drawer .si-reprise__check');
    if (!box) return;
    const error = document.querySelector('#cart-drawer #cart-errors');
    try {
      const response = await fetch(theme.routes.cartUpdate + '.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json', Accept:'application/json'},
        body: JSON.stringify({attributes:{"Reprise de l'ancien meuble":box.checked ? 'Oui' : ''}})
      });
      if (!response.ok) throw new Error('cart-update');
      const cart = await response.json();
      syncReprise(cart);
    } catch {
      if (error) {error.textContent = 'Votre choix sera enregistré à la validation du panier.';error.hidden = false;}
    }
  }, true);
}

if (!window.siDrawerLayoutBound) {
  window.siDrawerLayoutBound = true;
  const drawer = document.querySelector('#cart-drawer');
  let watchedFooter;
  const resize = new ResizeObserver(entries => {
    for (const entry of entries) drawer.style.setProperty('--si-footer-height', `${entry.target.offsetHeight}px`);
  });
  const syncCarousel = section => {
    const list = section.querySelector('.si-drawer-suggestions');
    const max = Math.max(0, list.scrollWidth - list.clientWidth);
    section.querySelector('[data-si-step="-1"]').disabled = list.scrollLeft < 2;
    section.querySelector('[data-si-step="1"]').disabled = list.scrollLeft >= max - 2;
    const dots = section.querySelector('.si-drawer-reco-dots');
    const pages = Math.max(1, Math.ceil(list.scrollWidth / list.clientWidth));
    if (dots.childElementCount !== pages) {
      dots.replaceChildren(...Array.from({length:pages}, (_,index) => {
        const button = document.createElement('button');
        button.type = 'button'; button.dataset.siPage = index;
        button.setAttribute('aria-label', `Suggestions : page ${index + 1} sur ${pages}`);
        return button;
      }));
    }
    const active = max ? Math.round(list.scrollLeft / max * (pages - 1)) : 0;
    [...dots.children].forEach((dot,index) => dot.setAttribute('aria-current', index === active ? 'true' : 'false'));
  };
  const setup = () => {
    const footer = drawer.querySelector('.si-drawer-footer');
    if (footer !== watchedFooter) {
      resize.disconnect(); watchedFooter = footer;
      if (footer) resize.observe(footer);
    }
    drawer.querySelectorAll('[data-si-carousel]').forEach(section => {
      const list = section.querySelector('.si-drawer-suggestions');
      if (!list.dataset.siReady) {
        list.dataset.siReady = 'true';
        list.addEventListener('scroll', () => syncCarousel(section), {passive:true});
      }
      syncCarousel(section);
    });
  };
  let pending;
  const schedule = () => {cancelAnimationFrame(pending); pending = requestAnimationFrame(setup);};
  new MutationObserver(schedule).observe(drawer, {childList:true,subtree:true});
  window.addEventListener('resize', schedule);
  drawer.addEventListener('click', event => {
    const button = event.target.closest('[data-si-step], [data-si-page]');
    if (!button) return;
    const section = button.closest('[data-si-carousel]');
    const list = section.querySelector('.si-drawer-suggestions');
    if (button.hasAttribute('data-si-step')) list.scrollBy({left:Number(button.dataset.siStep) * list.clientWidth,behavior:'smooth'});
    else {
      const pages = section.querySelector('.si-drawer-reco-dots').childElementCount;
      list.scrollTo({left:Number(button.dataset.siPage) / Math.max(1,pages - 1) * (list.scrollWidth - list.clientWidth),behavior:'smooth'});
    }
  });
  setup();
}
